import { createSelector } from "../helper";

const videoCallSelector = (state) => state.videoCalls;

export const audioVideoStateSelector = createSelector(videoCallSelector, (state) => ({
  video: state.video,
  audio: state.audio,
}));
